"use client";
import Image from "next/image";
import Link from "next/link";
import styles from "@/app/styles/offer.module.scss";
import useDeviceType from "@/app/utils/useDeviceType";
import Loading from "./loading";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from "react-bootstrap";
import https from "https";
import { useState, useEffect } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { formatEventDate } from "@/app/utils/formatDate";

const agent = new https.Agent({
  rejectUnauthorized: false,
});

async function getPageData() {
  const query = `
{
  pageData: pageBy(id: "cG9zdDoxMjg=") {
    pageBan {
      bannerText
      bannerSlider {
        desktopImage {
          node {
            mediaItemUrl
          }
        }
      }
    }
    eventsOffersData {
      entertainmentBackgroundImage {
        node {
          mediaItemUrl
        }
      }
      entertainmentCreativeHeading
      entertainmentDescription
      entertainmentFeatured {
        node {
          mediaItemUrl
        }
      }
      entertainmentFeaturedImage {
        node {
          mediaItemUrl
        }
      }
      entertainmentFeaturedTitle
      entertainmentHeading
      entertainmentMainTitle
      overviewCreativeHeading
      overviewHeading
      overviewText
    }
  }
  qleventoffers(
    first: 50
    where: {
      status: PUBLISH
      orderby: { field: MENU_ORDER, order: ASC }
    }
  ) {
    nodes {
      title
      eventsOffers {
        startDate
        endDate
        customizeDateText
        featureImage {
          node {
            mediaItemUrl
          }
        }
        description
        detailsList {
          description
          title
          listIcon {
            node {
              mediaItemUrl
            }
          }
        }
        downloadMenuOffer {
          node {
            mediaItemUrl
          }
        }
        detailsOffersInner {
          contentSet
          titleContentSet
        }
      }
      taxoffers {
        nodes {
          slug
          name
        }
      }
      slug
    }
  }
  taxoffers(where: {hideEmpty: true}) {
    nodes {
      slug
      name
    }
  }
}
  `;

  const res = await fetch(`${process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT}`, {
    httpsAgent: agent,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ query }),
    // next: {
    //   revalidate: 60,
    // },
  });

  const { data } = await res.json();

  // Sort event offers:
  // 1. No startDate first
  // 2. Then oldest startDate first
  if (data?.qleventoffers?.nodes) {
    data.qleventoffers.nodes.sort((a, b) => {
      const dateA = a.eventsOffers?.startDate;
      const dateB = b.eventsOffers?.startDate;

      // No startDate → first
      if (!dateA && !dateB) return 0;
      if (!dateA) return -1;
      if (!dateB) return 1;

      // Oldest startDate → first, latest → last
      return new Date(dateA).getTime() - new Date(dateB).getTime();
    });
  }

  return data;
}

export default function EventsOffers() {
  const deviceType = useDeviceType();

  const [page_data, setPageData] = useState(null);

  const [page_banner_text, setPageBannerText] = useState("");
  const [page_banner_sliders, setPageBannerSliders] = useState([]);

  const [overview_creative_heading, setOverviewCreativeHeading] = useState("");
  const [overview_heading, setOverviewHeading] = useState("");
  const [overview_description, setOverviewDescription] = useState("");

  const [ent_main_title, setEntMainTitle] = useState("");
  const [ent_bg_image, setEntBgImage] = useState("");
  const [ent_creative_heading, setEntCreativeHeading] = useState("");
  const [ent_heading, setEntHeading] = useState("");
  const [ent_description, setEntDescription] = useState("");

  const [ent_featured_image, setEntFeaturedImage] = useState("");
  const [ent_featured_title, setEntFeaturedTitle] = useState("");
  const [ent_featured_file, setEntFeaturedFile] = useState("");

  const [ent_list, setEntList] = useState([]);
  const [ent_all, setEntAll] = useState([]);
  const [type_list, setTypeList] = useState([]);
  const [description, setDescription] = useState([]);

  const [pre_loader_enabled, setPreLoaderEnable] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const page = await getPageData();
      if (page) {
        //console.log(page);
        if (page.pageData) {
          setPageData(page.pageData);
          if (page.pageData.pageBan) {
            if (page.pageData.pageBan.bannerText) {
              setPageBannerText(page.pageData.pageBan.bannerText);
            }
            if (page.pageData.pageBan.bannerSlider) {
              setPageBannerSliders(page.pageData.pageBan.bannerSlider);
            }
          }

          if (page.qlentertainments) {
            if (page.qlentertainments.nodes) {
              setEntList(page.qlentertainments.nodes);
            }
          }

          if (page.pageData.eventsOffersData) {
            if (page.pageData.eventsOffersData.overviewCreativeHeading) {
              setOverviewCreativeHeading(
                page.pageData.eventsOffersData.overviewCreativeHeading,
              );
            }
            if (page.pageData.eventsOffersData.overviewHeading) {
              setOverviewHeading(
                page.pageData.eventsOffersData.overviewHeading,
              );
            }
            if (page.pageData.eventsOffersData.overviewText) {
              setOverviewDescription(
                page.pageData.eventsOffersData.overviewText,
              );
            }

            if (page.pageData.eventsOffersData.entertainmentMainTitle) {
              setEntMainTitle(
                page.pageData.eventsOffersData.entertainmentMainTitle,
              );
            }
            if (page.pageData.eventsOffersData.entertainmentCreativeHeading) {
              setEntCreativeHeading(
                page.pageData.eventsOffersData.entertainmentCreativeHeading,
              );
            }
            if (page.pageData.eventsOffersData.entertainmentHeading) {
              setEntHeading(
                page.pageData.eventsOffersData.entertainmentHeading,
              );
            }
            if (page.pageData.eventsOffersData.entertainmentDescription) {
              setEntDescription(
                page.pageData.eventsOffersData.entertainmentDescription,
              );
            }
            if (page.pageData.eventsOffersData.entertainmentFeaturedTitle) {
              setEntFeaturedTitle(
                page.pageData.eventsOffersData.entertainmentFeaturedTitle,
              );
            }

            if (page.pageData.eventsOffersData.entertainmentBackgroundImage) {
              if (
                page.pageData.eventsOffersData.entertainmentBackgroundImage.node
              ) {
                if (
                  page.pageData.eventsOffersData.entertainmentBackgroundImage
                    .node.mediaItemUrl
                ) {
                  setEntBgImage(
                    page.pageData.eventsOffersData.entertainmentBackgroundImage
                      .node.mediaItemUrl,
                  );
                }
              }
            }

            if (page.pageData.eventsOffersData.entertainmentFeatured) {
              if (page.pageData.eventsOffersData.entertainmentFeatured.node) {
                if (
                  page.pageData.eventsOffersData.entertainmentFeatured.node
                    .mediaItemUrl
                ) {
                  setEntFeaturedFile(
                    page.pageData.eventsOffersData.entertainmentFeatured.node
                      .mediaItemUrl,
                  );
                }
              }
            }

            if (page.pageData.eventsOffersData.entertainmentFeaturedImage) {
              if (
                page.pageData.eventsOffersData.entertainmentFeaturedImage.node
              ) {
                if (
                  page.pageData.eventsOffersData.entertainmentFeaturedImage.node
                    .mediaItemUrl
                ) {
                  setEntFeaturedImage(
                    page.pageData.eventsOffersData.entertainmentFeaturedImage
                      .node.mediaItemUrl,
                  );
                }
              }
            }
          }

          if (page.qleventoffers) {
            if (page.qleventoffers.nodes) {
              setEntAll(page.qleventoffers.nodes);
            }
          }

          if (page.qleventoffers) {
            if (page.qleventoffers.description) {
              setDescription(page.qleventoffers.description);
            }
          }

          if (page.taxoffers) {
            if (page.taxoffers.nodes) {
              setTypeList(page.taxoffers.nodes);
            }
          }
        }
        setPreLoaderEnable(false);
      }
    };

    fetchData();
    return () => {};
  }, []);

  const settingsent = {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000,
    focusOnSelect: true,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    (async () => {
      const LocomotiveScroll = (await import("locomotive-scroll")).default;
      const locomotiveScroll = new LocomotiveScroll();
    })();
  }, []);

  if (pre_loader_enabled) {
    return <Loading />;
  }
  return (
    <>
      {page_banner_sliders && page_banner_sliders.length !== 0 && (
        <section className="inner-banner position-relative">
          <Carousel fade className="page-inner-carousel">
            {page_banner_sliders.map((banner_img, index) => {
              let imgurl = "";

              if (banner_img.desktopImage) {
                if (banner_img.desktopImage.node) {
                  if (banner_img.desktopImage.node.mediaItemUrl) {
                    imgurl = banner_img.desktopImage.node.mediaItemUrl;
                  }
                }
              }

              return (
                <Carousel.Item key={index}>
                  <Image
                    className={styles.banner_section_main_img}
                    src={imgurl}
                    width={deviceType !== "mobile" ? 1920 : 400}
                    height={deviceType !== "mobile" ? 1080 : 800}
                    alt="Banner Image"
                    priority
                    quality={deviceType !== "mobile" ? 100 : 80}
                  />
                </Carousel.Item>
              );
            })}
          </Carousel>
          <div className="inner-banner-text">
            <h2 className="all-caps section-heading-large section-heading--yellow">
              {page_banner_text}
            </h2>
          </div>
        </section>
      )}
      {page_banner_sliders && page_banner_sliders.length === 0 && (
        <section className="bg-dark-meroon green-mesh  inner-banner-text-wrap position-relative">
          <div className="inner-banner-text">
            <h2 className="all-caps section-heading-large section-heading--yellow m-0">
              {page_banner_text}
            </h2>
          </div>
        </section>
      )}

      {/* new design chamini */}
      <section className="section-padding-top section-padding-bottom bg-dark-meroon green-mesh ">
        <div className="middle-wrap z-top d-flex flex-wrap justify-content-between align-items-end">
          <div className={styles.leftHalfIffer}>
            <h6 className="creativeheader creative-heading-small creative-heading--white">
              {overview_creative_heading}
            </h6>
            <h1
              className={`section-heading paragraph--whiteTxt tab-text-left all-caps ${styles.tab_text_left}`}
            >
              {overview_heading}
            </h1>
          </div>
          <div className={styles.rightHalfIffer}>
            <p className="paragraph paragraph--white ">
              {overview_description}
            </p>
          </div>
        </div>
      </section>

      <section
        className={` ${styles.offersSection} bg-dark-meroon green-mesh offersSection`}
      >
        <div className="middle-wrap z-top d-flex flex-wrap justify-content-between align-items-end">
          <div className={styles.wrapOffersBoxes}>
            <Tabs defaultActiveKey="all" id="offer-tabs" className="offer-tabs">
              <Tab eventKey="all" title="All">
                <div className="">
                  <div className={` ${styles.offer_inner_box_list}`}>
                    {ent_all.map((all_item, index) => {
                      let imgurl = "";
                      let typetag = [];
                      let start_date = "";
                      let custom_date = "";
                      let end_date = "";
                      let page_slug = "";
                      let description = "";

                      if (all_item.eventsOffers) {
                        if (all_item.eventsOffers.featureImage) {
                          if (all_item.eventsOffers.featureImage.node) {
                            if (
                              all_item.eventsOffers.featureImage.node
                                .mediaItemUrl
                            ) {
                              imgurl =
                                all_item.eventsOffers.featureImage.node
                                  .mediaItemUrl;
                            }
                          }
                        }
                        if (all_item.eventsOffers.startDate) {
                          start_date = all_item.eventsOffers.startDate;
                        }
                        if (all_item.eventsOffers.customizeDateText) {
                          custom_date = all_item.eventsOffers.customizeDateText;
                        }
                        if (all_item.eventsOffers.endDate) {
                          end_date = all_item.eventsOffers.endDate;
                        }
                        if (all_item.eventsOffers.description) {
                          description = all_item.eventsOffers.description;
                        }
                      }

                      if (all_item.taxoffers) {
                        if (all_item.taxoffers.nodes) {
                          if (all_item.taxoffers.nodes) {
                            typetag = all_item.taxoffers.nodes.map(
                              (node) => node.name,
                            );
                          }
                        }
                      }

                      const eventDateText = formatEventDate(
                        start_date,
                        end_date,
                        custom_date,
                      );

                      const truncatedTitle =
                        all_item.title.length > 150
                          ? `${all_item.title.substring(0, 150)}[...]`
                          : all_item.title;

                      return (
                        <div
                          className={styles.offer_inner_box_wrap}
                          key={index}
                        >
                          <div className={styles.offer_inner_box}>
                            <Link
                              href={`/events-and-offers/${all_item.slug}`}
                              className={styles.offer_inner_box__img}
                            >
                              <Image
                                src={imgurl}
                                width={deviceType !== "mobile" ? 525 : 360}
                                height={deviceType !== "mobile" ? 400 : 400}
                                alt="Banner Image"
                                quality={deviceType !== "mobile" ? 100 : 80}
                              />
                              {typetag.length !== 0 && (
                                <div
                                  className={styles.offer_box_right_tag_wrap}
                                >
                                  {typetag.map((name, index) => (
                                    <div
                                      className={styles.offer_box_right_tag}
                                      key={index}
                                    >
                                      {name}
                                    </div>
                                  ))}
                                </div>
                              )}
                              <div className={styles.inrBxTitleDate}>
                                <p className={`${styles.dateInerBxOfer} m-0`}>
                                  {eventDateText}
                                </p>
                                <h6 className={styles.truncatedTitle}>
                                  {truncatedTitle}
                                </h6>
                              </div>
                            </Link>
                            <div
                              className={styles.offer_inner_box__content}
                              key={index}
                            >
                              <div className={styles.inrBxDesc}>
                                {description}
                              </div>
                              <Link
                                className={`next-btn next-btn--white ${styles.nxtBtn_More}`}
                                href={`/events-and-offers/${all_item.slug}`}
                              >
                                <span className="next-btn--text">
                                  more details{" "}
                                  <span>
                                    {" "}
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="11"
                                      height="18"
                                      viewBox="0 0 11 18"
                                      fill="none"
                                    >
                                      <path
                                        d="M1 1.04004L9 9.04022L1 17.04"
                                        stroke="white"
                                        strokeWidth="2"
                                      />
                                    </svg>
                                  </span>
                                </span>
                              </Link>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      </section>

      {/* end new design */}
    </>
  );
}
